import nlnAxios from "../../../api/nlnAxios";


//Create FAQs

const createCollection = async (resourceId, token) => {

    const config = {
        headers: {
            Authorization: `Bearer ${token}`
    }
}
    const response = await nlnAxios.post("/library/resources/collections/items/" + resourceId, token);
    return response.data;
}

//Get FAQs

const getCollection = async (token) => {

    const config = {
        headers: {
            Authorization: `Bearer ${token}`
    }
}

    const response = await nlnAxios.get("/library/resources/collections/items");

    return response.data;
}

const deleteCollection = async (resourceCollectionItemId, token) => {

    const config = {
        headers: {
            Authorization: `Bearer ${token}`
        }

    }

    const response = await nlnAxios.delete("/library/resources/collections/items/" + resourceCollectionItemId);

    return response.data;
}



const collectionService = {
    createCollection,
    getCollection,
    deleteCollection
}

export default collectionService;